// init YoutTube API
export function ytplayer(YouTubePlayer) {
    $(".js-video").each((index, item) => {
        let player;
        let $container = $(item).closest(".js-video-container");
        let $mute = $container.find(".js-video-mute");
        let $close = $container.find(".js-video-close");
        let $layout = $container.find(".js-video-layout");
        let $infoHolder = $container.closest(".intro").find(".intro-info");
        let id = $(item).attr("id") + index;
        let videoId = $(item).attr("data-video");
        $(item).attr("id", id);
        player = YouTubePlayer(id, {
            videoId: videoId,
            host: "https://www.youtube.com",
            playerVars: {
                // controls: 0,
                rel: 0,
                showinfo: 0,
                cc_load_policy: 0,
                iv_load_policy: 3
                // list: 0,
            }
        });

        $layout.on("click", function() {
            let isVideoPlaying = $(this).hasClass("is-playing");
            let $introContainer = $(this).closest(".js-main-intro");
            if (isVideoPlaying) {
                player.pauseVideo();
                $(this).removeClass("is-playing");
                $container.removeClass("is-active");
            } else {
                $(this).addClass("is-playing");
                player.playVideo();
                $container.addClass("is-active");
            }
            if ($introContainer.length) {
                $introContainer.toggleClass("is-active");
            }
        });

        $mute.on("click", function(e) {
            let isVideoMuted = $(this).hasClass("is-muted");
            if (isVideoMuted) {
                player.unMute();
                $(this).removeClass("is-muted");
            } else {
                $(this).addClass("is-muted");
                player.mute();
            }
            e.preventDefault();
        });
        if($infoHolder.length) {
            $infoHolder.on("click", function(e) {
                if($(e.target).hasClass("intro-info")) {
                    layout.trigger("click");
                }
            });
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/player.js